import { createContext, useContext } from "react";

// Contexto del Chat con Telegram: estado de la cuenta, lista de chats, no-leídos y la burbuja/ancla. El proveedor vive en
// components/telegram/TelegramProvider.jsx. Sin proveedor (p. ej. el Layout en pruebas sueltas) todo queda en reposo, nunca rompe.
const NOOP = {
  carga: "cargando", status: null, owner: "", setOwner: () => {}, puedeLeer: false,
  chats: [], total: 0, folderCounts: { all: 0, groups: 0, personal: 0, bots: 0 }, sendEnabled: false, chatsListos: false, chatsError: "",
  unreadTotal: 0, sync: "ok", alerta: null, cerrarAlerta: () => {},
  refreshStatus: async () => {}, refreshChats: async () => {},
  ui: { modo: "burbuja", abierto: false, grande: false, ancho: 400, chatActivo: "" },
  abrirBurbuja: () => {}, cerrarBurbuja: () => {}, setModo: () => {}, setGrande: () => {}, setAncho: () => {}, setChatActivo: () => {}, abrirChat: () => {},
};
export const TelegramContext = createContext(null);
export const useTelegram = () => useContext(TelegramContext) || NOOP;
